// Mount the gaze-conditioned eye branch: bundle bytes into the eye system, plus the debug global.

import { loadEyeAssetsFromBundle } from './eyeAssets.ts'
import type { BundleBytes, EyeBranchSpec } from './eyeAssets.ts'
import { createEyeSystem } from './eyeSystem.ts'
import type { CameraLike } from './eyePass.ts'
import type { SceneLike } from './eyeSystem.ts'

export type MountEyeBranchOptions = {
  scene: SceneLike
  camera: CameraLike
  spec: EyeBranchSpec
  getBytes: BundleBytes
  isActive: () => boolean
}

/** Camera moves arrive through `__ORBIT_CONTROLS__`, as for every view-dependent consumer. */
export async function mountEyeBranch(options: MountEyeBranchOptions) {
  const { scene, camera, spec, getBytes, isActive } = options
  const assets = await loadEyeAssetsFromBundle(spec, getBytes)
  const system = await createEyeSystem({
    scene,
    camera,
    assets,
    isActive,
    lookAtCamera: spec.lookAtCamera !== false,
    onDispose: () => {
      if ((window as any).__OGS_EYES__ === system) delete (window as any).__OGS_EYES__
    },
  })
  ;(window as any).__OGS_EYES__ = system
  return system
}
